import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/category/layer/layer.category.layer.query.gql"
import type {
  LayerCategoryLayerQuery,
  LayerCategoryLayerQueryVariables,
} from "@/v2-backoffice-client/layer/category/layer/__types__/layer.category.layer.query"

type Options = QueryHookOptions<
  LayerCategoryLayerQuery,
  LayerCategoryLayerQueryVariables
>

export function useLayerCategoryLayerQuery(options?: Options) {
  return useQuery<LayerCategoryLayerQuery, LayerCategoryLayerQueryVariables>(
    query,
    options,
  )
}
